import axios from "axios";

class HttpService {
  constructor(baseURL) {
    this.api = axios.create({
       baseURL: `https://2v-api.logt.com.br`,
      //baseURL: "http://localhost:3000",
    });

    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response) {
          // Token expirado ou inválido
          if (error.response.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
          }
          // Credenciais inválidas
          // else if (error.response.status === 403) {
          //   alert(
          //     "Credenciais inválidas. Por favor, verifique seus dados e tente novamente."
          //   );
          // }
        }
        return Promise.reject(error);
      }
    );

  }

  get(url, config = {}) {
    return this.api.get(url, config);
  }

  post(url, data, config = {}) {
    return this.api.post(url, data, config);
  }

  put(url, data, config = {}) {
    return this.api.put(url, data, config);
  }

  delete(url, config = {}) {
    return this.api.delete(url, config);
  }
}

export default HttpService;
